import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { textoDoItemNaNota, descricaoAlemDoTexto } from '../utils/itemNaNota';
import { fiscalService, certificateService, apiErrorMessage } from '../services/api';
import { fmtDate, fmtDateTime, getCurrentMonthStr } from '../utils/formatters';
import ListToolbar, { ToolbarSearch } from './shared/ListToolbar';
import PeriodSelector, { PeriodFilter, defaultPeriodFilter, periodToParams } from './PeriodSelector';
import ClientPopover from './ClientPopover';
import CascaDeModal from './shared/CascaDeModal';
import MaisAcoes from './shared/MaisAcoes';
import { TONE_BADGE, TONE_BORDER, TONE_SURFACE, TONE_TEXT } from '../utils/statusColors';
import {
  CELULA, CascaDaLista, TabelaDaLista, CabecalhoDaLista, ColunaDaLista, LinhaDaLista, CelulaCliente, CelulaDinheiro, CelulaAcoes,
  CabecalhoInterno, CartaoDoTopo,
} from './shared/lista/PecasDaLista';
import { useConfirmarPerigo } from './shared/ConfirmDialog';
import { BarChart, Bar, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell,
         XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Carga, campo, EstadoDaLista, A_PROPRIA_LISTA_DIZ_O_VAZIO, textos, mensagemDoErroDeCarga, useEstadoDaCarga } from '../design';
import { STATUS_DA_NOTA, GRUPOS_DE_STATUS, GrupoDeStatus, seloDoStatusDaNota, passaNoStatus, passaNoTipo, TIPOS_DA_LISTA, tipoNoServidor, ambienteDaNota, fimDaChave } from '../utils/tomDoStatusDaNota';
import { rotuloDoRecorte, notasParaTransmitir, exportacaoDoPeriodo, mesDaDeclaracao, confirmacaoDeCancelarNota, avisoDoUpload, confirmacaoDeExcluirCertificado } from '../utils/notasFiscais';

const Icon = ({ name, className = 'w-5 h-5' }: { name: string; className?: string }) => {
  const icons: any = {
    fileText: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' /></svg>,
    x: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' /></svg>,
    search: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' /></svg>,
    eye: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 12a3 3 0 11-6 0 3 3 0 016 0z' /><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z' /></svg>,
    download: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4' /></svg>,
    upload: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12' /></svg>,
    trash: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16' /></svg>,
    refresh: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' /></svg>,
    check: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' /></svg>,
    alertCircle: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' /></svg>,
    play: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z' /><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 12a9 9 0 11-18 0 9 9 0 0118 0z' /></svg>,
    shield: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' /></svg>,
    ban: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636' /></svg>,
  };
  return icons[name] || null;
};


const fmt = (v: any) => { const n = parseFloat(String(v)); return isNaN(n) ? '0,00' : n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

// O selo do status sai do mapa único dos seis (utils/tomDoStatusDaNota, decisão S1 de 03/11/2026), na lista e no detalhe.

const typeColors: Record<string, string> = {
  'nfse': 'bg-blue-500/20 text-blue-400',
  'nfcom': 'bg-purple-500/20 text-purple-400',
};

const typeLabels: Record<string, string> = {
  'nfse': 'NFS-e',
  'nfcom': 'NFCom',
};

const Toast = ({ message, type, onClose }: { message: string; type: 'success' | 'error' | 'warning' | 'info'; onClose: () => void }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);
  const colors = { success: 'bg-central-elevado border-central-borda', error: 'bg-red-500 border-red-600', warning: 'bg-yellow-500 border-yellow-600', info: 'bg-blue-500 border-blue-600' };
  const icons = { success: '\u2713', error: '\u2715', warning: '\u26A0', info: '\u2139' };
  return (
    <div className={`fixed bottom-4 right-4 z-[100] flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg text-white ${colors[type]}`}>
      <span className="text-lg">{icons[type]}</span>
      <span className="font-medium">{message}</span>
      <button onClick={onClose} className="ml-2 hover:opacity-70">&times;</button>
    </div>
  );
};

// === Monitoring Chart Colors ===
const CHART_COLORS = {
  nfse: '#60a5fa',
  nfcom: '#c084fc',
  authorized: '#4ade80',
  error: '#f87171',
  draft: '#94a3b8',
  processing: '#facc15',
  cancelled: '#6b7280',
};

const STATUS_COLOR_MAP: Record<string, string> = {
  'Autorizada': CHART_COLORS.authorized,
  'Erro': CHART_COLORS.error,
  'Rejeitada': CHART_COLORS.error,
  // S1 (03/11/2026): as mesmas leituras do selo da lista, Rascunho âmbar e Processando azul.
  'Rascunho': '#fbbf24',
  'Processando': '#60a5fa',
  'Cancelada': CHART_COLORS.cancelled,
};

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload) return null;
  return (
    <div className="bg-slate-800 border border-slate-600 rounded-lg p-3 shadow-xl">
      <p className="text-white font-medium text-sm">{label}</p>
      {payload.map((entry: any, i: number) => (
        <p key={i} className="text-sm" style={{ color: entry.color }}>
          {entry.name}: {entry.value}
        </p>
      ))}
    </div>
  );
};

const MonitoringContent: React.FC<{
  monitoring: any;
  monitoringLoading: boolean;
  monitoringPeriod: '30d' | '90d' | '12m';
  setMonitoringPeriod: (p: '30d' | '90d' | '12m') => void;
  loadMonitoring: () => void;
  sefazStatus: any;
  certInfo: any;
  handleRetry: (doc: any) => void;
  actionLoading: number | null;
  /** A carga do monitoramento e de que período é o que está em `monitoring` (D1: nunca o de outro período). */
  carga: Pick<Carga, 'estado' | 'erro' | 'atualizadoEm'>;
  monitoramentoDe: string | null;
}> = ({ monitoring, monitoringLoading, monitoringPeriod, setMonitoringPeriod, loadMonitoring, sefazStatus, certInfo, handleRetry, actionLoading, carga, monitoramentoDe }) => {
  const doPeriodo = monitoramentoDe === monitoringPeriod;

  // Transform byMonth for stacked bar chart
  const chartMonthData = useMemo(() => {
    if (!monitoring?.byMonth) return [];
    const monthMap: Record<string, any> = {};
    monitoring.byMonth.forEach((r: any) => {
      if (!monthMap[r.month]) monthMap[r.month] = { month: r.month, nfse: 0, nfcom: 0 };
      if (r.type === 'nfse') monthMap[r.month].nfse += parseInt(r.count);
      if (r.type === 'nfcom') monthMap[r.month].nfcom += parseInt(r.count);
    });
    return Object.values(monthMap).sort((a: any, b: any) => a.month.localeCompare(b.month));
  }, [monitoring]);

  // Transform dailyTrend for area chart
  const chartDailyData = useMemo(() => {
    if (!monitoring?.dailyTrend) return [];
    const dayMap: Record<string, any> = {};
    monitoring.dailyTrend.forEach((r: any) => {
      if (!dayMap[r.date]) dayMap[r.date] = { date: r.date.slice(5), nfse: 0, nfcom: 0 };
      if (r.type === 'nfse') dayMap[r.date].nfse += parseInt(r.count);
      if (r.type === 'nfcom') dayMap[r.date].nfcom += parseInt(r.count);
    });
    return Object.values(dayMap).sort((a: any, b: any) => a.date.localeCompare(b.date));
  }, [monitoring]);

  // Transform summary for pie chart
  const chartStatusData = useMemo(() => {
    if (!monitoring?.summary) return [];
    const statusMap: Record<string, number> = {};
    monitoring.summary.forEach((r: any) => {
      statusMap[r.status] = (statusMap[r.status] || 0) + parseInt(r.count);
    });
    return Object.entries(statusMap).map(([name, value]) => ({ name, value }));
  }, [monitoring]);

  // Compute success rate by month for line chart
  const chartSuccessData = useMemo(() => {
    if (!monitoring?.byMonth) return [];
    const monthMap: Record<string, { total: number; authorized: number }> = {};
    monitoring.byMonth.forEach((r: any) => {
      if (!monthMap[r.month]) monthMap[r.month] = { total: 0, authorized: 0 };
      const count = parseInt(r.count);
      monthMap[r.month].total += count;
      if (r.status === 'Autorizada') monthMap[r.month].authorized += count;
    });
    return Object.entries(monthMap)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([month, data]) => ({
        month,
        taxa: data.total > 0 ? parseFloat(((data.authorized / data.total) * 100).toFixed(1)) : 0,
      }));
  }, [monitoring]);

  // Financial totals
  const nfseFinancial = monitoring?.financial?.find((f: any) => f.type === 'nfse');
  const nfcomFinancial = monitoring?.financial?.find((f: any) => f.type === 'nfcom');

  const periodLabels: Record<string, string> = { '30d': '30 dias', '90d': '90 dias', '12m': '12 meses' };

  return (
    <div className="space-y-6">
      {/* Header: Period selector + refresh + environment */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {(['30d', '90d', '12m'] as const).map(p => (
            <button
              key={p}
              onClick={() => setMonitoringPeriod(p)}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                monitoringPeriod === p ? 'bg-slate-600 text-white font-semibold' : 'bg-slate-800 text-slate-400 hover:text-white border border-slate-700'
              }`}
            >
              {periodLabels[p]}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          {monitoringLoading && (
            <div className="flex items-center gap-2 text-slate-400 text-sm">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-500"></div>
              Atualizando...
            </div>
          )}
          {/* Sem leitura, o selo dizia "Homologação": a ausência de `environment` virava afirmação. */}
          <span data-kpi="ambiente" className={`px-2.5 py-1 rounded-full text-xs font-medium ${
            !doPeriodo ? 'bg-slate-700 text-slate-400' : monitoring?.environment === 'producao' ? TONE_BADGE.neutral : TONE_BADGE.warning
          }`}>
            {!doPeriodo ? textos.numeroSemFonte : monitoring?.environment === 'producao' ? 'Producao' : 'Homologacao'}
          </span>
          <button onClick={loadMonitoring} className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg" title="Atualizar">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
          </button>
        </div>
      </div>

      {/* KPIs, gráficos e erros: só do período escolhido. Sem leitura, diziam 0, "Nenhum erro" em verde. */}
      <EstadoDaLista
        carga={doPeriodo ? carga : { ...carga, estado: carga.estado === 'erro' ? 'erro' : 'carregando', atualizadoEm: null }}
        temDados={doPeriodo}
        oQue={`o monitoramento de ${periodLabels[monitoringPeriod]}`}
        onTentarDeNovo={loadMonitoring}
        vazio={A_PROPRIA_LISTA_DIZ_O_VAZIO}
      >
      <div className="space-y-6">
      {/* KPI Cards */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="text-sm text-slate-400">Total Documentos</div>
          <div className="text-3xl font-bold text-white">{monitoring?.totalDocuments ?? 0}</div>
          <div className="text-xs text-slate-500 mt-1">{periodLabels[monitoringPeriod]}</div>
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="text-sm text-slate-400">Taxa de Sucesso</div>
          <div className={`text-3xl font-bold ${
            (monitoring?.successRate ?? 0) >= 95 ? 'text-white' :
            (monitoring?.successRate ?? 0) >= 80 ? 'text-yellow-400' : 'text-red-400'
          }`}>
            {monitoring?.successRate ?? 0}%
          </div>
          <div className="text-xs text-slate-500 mt-1">{monitoring?.authorizedCount ?? 0} autorizadas</div>
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="text-sm text-slate-400">NFS-e Autorizadas</div>
          <div className="text-3xl font-bold text-blue-400">{nfseFinancial?.count ?? 0}</div>
          <div className="text-xs text-slate-500 mt-1">R$ {fmt(nfseFinancial?.totalValue ?? 0)}</div>
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="text-sm text-slate-400">NFCom Autorizadas</div>
          <div className="text-3xl font-bold text-purple-400">{nfcomFinancial?.count ?? 0}</div>
          <div className="text-xs text-slate-500 mt-1">R$ {fmt(nfcomFinancial?.totalValue ?? 0)}</div>
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="text-sm text-slate-400">Erros / Rejeicoes</div>
          <div className={`text-3xl font-bold ${(monitoring?.errorCount ?? 0) > 0 ? 'text-red-400' : 'text-white'}`}>
            {monitoring?.errorCount ?? 0}
          </div>
          <div className="text-xs text-slate-500 mt-1">{(monitoring?.errorCount ?? 0) === 0 ? 'Nenhum erro' : 'Requer atencao'}</div>
        </div>
      </div>

      {/* Charts Row 1: Bar + Line */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <h3 className="text-sm font-medium text-white mb-4">Emissoes por Mes</h3>
          {chartMonthData.length > 0 ? (
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={chartMonthData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
                <XAxis dataKey="month" tick={{ fill: '#94a3b8', fontSize: 12 }} />
                <YAxis tick={{ fill: '#94a3b8', fontSize: 12 }} allowDecimals={false} />
                <Tooltip content={<CustomTooltip />} />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                <Bar dataKey="nfse" name="NFS-e" fill={CHART_COLORS.nfse} radius={[4, 4, 0, 0]} />
                <Bar dataKey="nfcom" name="NFCom" fill={CHART_COLORS.nfcom} radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="flex items-center justify-center h-[260px] text-slate-500 text-sm">Sem dados no periodo</div>
          )}
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <h3 className="text-sm font-medium text-white mb-4">Taxa de Sucesso por Mes (%)</h3>
          {chartSuccessData.length > 0 ? (
            <ResponsiveContainer width="100%" height={260}>
              <LineChart data={chartSuccessData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
                <XAxis dataKey="month" tick={{ fill: '#94a3b8', fontSize: 12 }} />
                <YAxis domain={[0, 100]} tick={{ fill: '#94a3b8', fontSize: 12 }} />
                <Tooltip content={<CustomTooltip />} />
                <Line type="monotone" dataKey="taxa" name="Taxa %" stroke={CHART_COLORS.authorized} strokeWidth={2} dot={{ r: 4, fill: CHART_COLORS.authorized }} />
              </LineChart>
            </ResponsiveContainer>
          ) : (
            <div className="flex items-center justify-center h-[260px] text-slate-500 text-sm">Sem dados no periodo</div>
          )}
        </div>
      </div>

      {/* Charts Row 2: Area + Pie */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <h3 className="text-sm font-medium text-white mb-4">Tendencia Diaria</h3>
          {chartDailyData.length > 0 ? (
            <ResponsiveContainer width="100%" height={260}>
              <AreaChart data={chartDailyData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
                <XAxis dataKey="date" tick={{ fill: '#94a3b8', fontSize: 11 }} interval="preserveStartEnd" />
                <YAxis tick={{ fill: '#94a3b8', fontSize: 12 }} allowDecimals={false} />
                <Tooltip content={<CustomTooltip />} />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                <Area type="monotone" dataKey="nfse" name="NFS-e" stackId="1" stroke={CHART_COLORS.nfse} fill={CHART_COLORS.nfse} fillOpacity={0.4} />
                <Area type="monotone" dataKey="nfcom" name="NFCom" stackId="1" stroke={CHART_COLORS.nfcom} fill={CHART_COLORS.nfcom} fillOpacity={0.4} />
              </AreaChart>
            </ResponsiveContainer>
          ) : (
            <div className="flex items-center justify-center h-[260px] text-slate-500 text-sm">Sem dados no periodo</div>
          )}
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <h3 className="text-sm font-medium text-white mb-4">Distribuicao por Status</h3>
          {chartStatusData.length > 0 ? (
            <ResponsiveContainer width="100%" height={260}>
              <PieChart>
                <Pie data={chartStatusData} cx="50%" cy="50%" innerRadius={60} outerRadius={100} paddingAngle={3} dataKey="value" label={({ name, percent }: any) => `${name} ${(percent * 100).toFixed(0)}%`}>
                  {chartStatusData.map((entry: any, i: number) => (
                    <Cell key={i} fill={STATUS_COLOR_MAP[entry.name] || '#94a3b8'} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <div className="flex items-center justify-center h-[260px] text-slate-500 text-sm">Sem dados no periodo</div>
          )}
        </div>
      </div>

      {/* Top 10 Clients */}
      {monitoring?.topClients && monitoring.topClients.length > 0 && (
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl overflow-hidden">
          <div className="p-4 border-b border-slate-700">
            <h3 className="text-sm font-medium text-white">Top 10 Clientes</h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <CabecalhoInterno>
                <tr className="border-b border-slate-700">
                  <th className="p-3 text-left text-xs font-medium text-slate-400 uppercase">Cliente</th>
                  <th className="p-3 text-center text-xs font-medium text-slate-400 uppercase">Total</th>
                  <th className="p-3 text-center text-xs font-medium text-slate-400 uppercase">Autorizados</th>
                  <th className="p-3 text-center text-xs font-medium text-slate-400 uppercase">Erros</th>
                  <th className="p-3 text-right text-xs font-medium text-slate-400 uppercase">Valor R$</th>
                  <th className="p-3 text-center text-xs font-medium text-slate-400 uppercase">% Sucesso</th>
                </tr>
              </CabecalhoInterno>
              <tbody>
                {monitoring.topClients.map((c: any, i: number) => {
                  const total = parseInt(c.total);
                  const authorized = parseInt(c.authorized);
                  const errors = parseInt(c.errors);
                  const rate = total > 0 ? ((authorized / total) * 100).toFixed(0) : '0';
                  const hasHighError = total > 0 && errors / total > 0.1;
                  return (
                    <tr key={i} className={`border-b border-slate-700/50 ${hasHighError ? 'bg-red-900/10' : 'hover:bg-slate-700/30'}`}>
                      <td className="p-3 text-sm text-white font-medium">{c.clientName}</td>
                      <td className="p-3 text-sm text-slate-300 text-center">{total}</td>
                      <td className="p-3 text-sm text-slate-300 text-center">{authorized}</td>
                      <td className="p-3 text-sm text-center">
                        <span className={errors > 0 ? 'text-red-400 font-medium' : 'text-slate-500'}>{errors}</span>
                      </td>
                      <td className="p-3 text-sm text-white text-right font-medium">R$ {fmt(c.totalValue)}</td>
                      <td className="p-3 text-center">
                        <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                          parseFloat(rate) >= 95 ? TONE_BADGE.neutral :
                          parseFloat(rate) >= 80 ? 'bg-yellow-500/20 text-yellow-400' :
                          'bg-red-500/20 text-red-400'
                        }`}>
                          {rate}%
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Recent Errors */}
      {monitoring?.recentErrors && monitoring.recentErrors.length > 0 && (
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl overflow-hidden">
          <div className="p-4 border-b border-slate-700">
            <h3 className="text-sm font-medium text-red-400">Erros Recentes</h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <CabecalhoInterno>
                <tr className="border-b border-slate-700">
                  <th className="p-3 text-left text-xs font-medium text-slate-400 uppercase">Tipo</th>
                  <th className="p-3 text-left text-xs font-medium text-slate-400 uppercase">Cliente</th>
                  <th className="p-3 text-left text-xs font-medium text-slate-400 uppercase">Ref.</th>
                  <th className="p-3 text-right text-xs font-medium text-slate-400 uppercase">Valor</th>
                  <th className="p-3 text-left text-xs font-medium text-slate-400 uppercase">Erro</th>
                  <th className="p-3 text-center text-xs font-medium text-slate-400 uppercase">Retries</th>
                  <th className="p-3 text-left text-xs font-medium text-slate-400 uppercase">Data</th>
                  <th className="p-3 text-center text-xs font-medium text-slate-400 uppercase">Ação</th>
                </tr>
              </CabecalhoInterno>
              <tbody>
                {monitoring.recentErrors.map((e: any) => (
                  <tr key={e.id} className="border-b border-slate-700/50 hover:bg-slate-700/30">
                    <td className="p-3">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${typeColors[e.type] || 'bg-slate-500/20 text-slate-300'}`}>
                        {typeLabels[e.type] || e.type}
                      </span>
                    </td>
                    <td className="p-3 text-sm text-white">{e.clientName}</td>
                    <td className="p-3 text-sm text-slate-400">{e.referenceMonth}</td>
                    <td className="p-3 text-sm text-white text-right">R$ {fmt(e.totalValue)}</td>
                    <td className="p-3 text-sm text-red-300 max-w-[300px] truncate" title={e.lastError}>{e.lastError || '-'}</td>
                    <td className="p-3 text-sm text-slate-400 text-center">{e.retryCount}</td>
                    <td className="p-3 text-sm text-slate-400">{fmtDateTime(e.updatedAt)}</td>
                    <td className="p-3 text-center">
                      <button
                        onClick={() => handleRetry(e)}
                        disabled={actionLoading === e.id}
                        className="p-1.5 text-slate-400 hover:text-yellow-400 hover:bg-slate-700 rounded disabled:opacity-50"
                        title="Retransmitir"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      </div>
      </EstadoDaLista>

      {/* System Health */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="text-xs text-slate-400 mb-1">SEFAZ</div>
          <div className={`text-lg font-bold ${!sefazStatus ? 'text-slate-500' : sefazStatus.online ? 'text-white' : 'text-red-400'}`}>
            {!sefazStatus ? textos.numeroSemFonte : sefazStatus.online ? 'Online' : 'Offline'}
          </div>
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="text-xs text-slate-400 mb-1">Certificado Digital</div>
          <div className={`text-lg font-bold ${
            certInfo?.daysUntilExpiry == null ? 'text-slate-500' :
            certInfo.daysUntilExpiry < 30 ? 'text-red-400' :
            certInfo.daysUntilExpiry < 90 ? 'text-yellow-400' : 'text-white'
          }`}>
            {certInfo?.daysUntilExpiry != null ? `${certInfo.daysUntilExpiry} dias` : textos.numeroSemFonte}
          </div>
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="text-xs text-slate-400 mb-1">Ambiente</div>
          <div className={`text-lg font-bold ${!doPeriodo ? 'text-slate-500' : monitoring?.environment === 'producao' ? 'text-white' : 'text-yellow-400'}`}>
            {!doPeriodo ? textos.numeroSemFonte : monitoring?.environment === 'producao' ? 'Producao' : 'Homologacao'}
          </div>
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="text-xs text-slate-400 mb-1">Tempo Medio Processamento</div>
          {monitoring?.processingStats?.length > 0 ? (
            <div className="space-y-1">
              {monitoring.processingStats.map((p: any) => (
                <div key={p.type} className="flex items-center gap-2">
                  <span className={`text-xs font-medium ${p.type === 'nfse' ? 'text-blue-400' : 'text-purple-400'}`}>
                    {p.type === 'nfse' ? 'NFS-e' : 'NFCom'}:
                  </span>
                  <span className="text-sm text-white font-bold">{p.avgMinutes}min</span>
                  <span className="text-xs text-slate-500">({p.count})</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-lg font-bold text-slate-500">-</div>
          )}
        </div>
      </div>
    </div>
  );
};

const FiscalTab: React.FC<{ subView?: string }> = ({ subView = 'documents' }) => {
  const confirmarPerigo = useConfirmarPerigo();
  const activeTab = subView as 'documents' | 'certificates' | 'monitoring';
  const [monitoring, setMonitoring] = useState<any>(null);
  const [monitoringPeriod, setMonitoringPeriod] = useState<'30d' | '90d' | '12m'>('30d');
  const [monitoringLoading, setMonitoringLoading] = useState(false);
  const [documents, setDocuments] = useState<any[]>([]);
  const [dashboard, setDashboard] = useState<any>(null);
  const [sefazStatus, setSefazStatus] = useState<any>(null);
  const [certInfo, setCertInfo] = useState<any>(null);
  const [certificates, setCertificates] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const currentMonthStr = getCurrentMonthStr();
  const [periodFilter, setPeriodFilter] = useState<PeriodFilter>(defaultPeriodFilter());
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [downloadIds, setDownloadIds] = useState<Set<number>>(new Set());
  const [lastClickedIdx, setLastClickedIdx] = useState<number | null>(null);
  const [zipLoading, setZipLoading] = useState(false);
  const [xmlZipLoading, setXmlZipLoading] = useState(false);
  const [xmlLoadingId, setXmlLoadingId] = useState<number | null>(null);
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' | 'warning' | 'info' } | null>(null);
  /** A declaração do MHemann pedida: o mês, e o que voltou para ELE (nunca a de outro mês). */
  const [fust, setFust] = useState<{ mes: string | null; motivo: string | null; dados: any; erro: string | null; carregando: boolean } | null>(null);
  const [showFustModal, setShowFustModal] = useState(false);
  const [showManualPendingModal, setShowManualPendingModal] = useState(false);
  const [xmlBatchLoading, setXmlBatchLoading] = useState(false);

  // Modals
  const [detailDoc, setDetailDoc] = useState<any>(null);
  const [cancelDoc, setCancelDoc] = useState<any>(null);
  const [cancelReason, setCancelReason] = useState('');
  const [cancelReasonsList, setCancelReasonsList] = useState<any[]>([]);
  const [selectedReasonId, setSelectedReasonId] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [showUploadCert, setShowUploadCert] = useState(false);
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [uploadPassword, setUploadPassword] = useState('');
  const [uploadName, setUploadName] = useState('');
  const [uploadType, setUploadType] = useState<'empresa' | 'pessoal'>('empresa');
  const [actionLoading, setActionLoading] = useState<number | null>(null);
  const [batchLoading, setBatchLoading] = useState(false);
  /** Progresso da transmissão em blocos (null = sem lote em andamento). */
  const [batchProgress, setBatchProgress] = useState<{ done: number; total: number } | null>(null);
  const [excelExporting, setExcelExporting] = useState(false);

  const showToast = useCallback((message: string, type: 'success' | 'error' | 'warning' | 'info') => {
    setToast({ message, type });
  }, []);

  // ⛔ AS CARGAS NÃO CALAM (10/10/2026, medição do item 11). Os sete loaders só logavam ou zeravam: com a API fora a
  // tela dizia "Nenhum documento fiscal · Crie documentos a partir das faturas", "Online" para a SEFAZ que ninguém
  // leu, "Nenhum certificado cadastrado" ao lado do Upload (que DESATIVA o certificado ativo), e o Monitoramento
  // "Nenhum erro" em "Homologação". Cada fonte tem agora o seu estado, e a tela diz quando não leu.
  const cargaDocs = useEstadoDaCarga();
  const cargaDash = useEstadoDaCarga();
  const cargaCerts = useEstadoDaCarga();
  const cargaMon = useEstadoDaCarga();
  const rodarDocs = cargaDocs.rodar;
  const rodarDash = cargaDash.rodar;
  const rodarCerts = cargaCerts.rodar;
  const rodarMon = cargaMon.rodar;
  const [sefazErro, setSefazErro] = useState<string | null>(null);
  const [certInfoErro, setCertInfoErro] = useState<string | null>(null);
  const [motivosErro, setMotivosErro] = useState<string | null>(null);

  // A LISTA VALE SÓ PARA O RECORTE EM QUE FOI LIDA (D1a). Trocar período, tipo ou status e a carga falhar deixava na
  // tela a lista do recorte ANTERIOR com o rótulo do novo: "Transmitir", "Baixar" e "Excluir" agiam sobre o mês que o
  // operador julgava ser outro. Agora a lista de outro recorte não aparece: a tela diz que este não carregou.
  // K1 (03/11/2026): o servidor devolve o período inteiro, e tipo e status recortam só a LISTA. Os cartões contam o mês,
  // e não o que o próprio filtro deixou: antes, filtrar Cancelada zerava Autorizadas.
  const chaveDoRecorte = JSON.stringify({ p: periodToParams(periodFilter) });
  const recorteAtual = useRef(chaveDoRecorte);
  recorteAtual.current = chaveDoRecorte;
  const [docsDoRecorte, setDocsDoRecorte] = useState<string | null>(null);
  const [monitoramentoDe, setMonitoramentoDe] = useState<string | null>(null);

  const loadDocuments = useCallback(async () => {
    const params: any = {};
    const p = periodToParams(periodFilter);
    if (p.month) params.referenceMonth = p.month;
    if (p.startDate) params.startDate = p.startDate;
    if (p.endDate) params.endDate = p.endDate;
    const chave = JSON.stringify({ p });
    await rodarDocs(async () => {
      const data = await fiscalService.getAll(params);
      // Resposta de um recorte que já saiu da tela não entra.
      if (recorteAtual.current !== chave) return;
      setDocuments(Array.isArray(data) ? data : data.data || []);
      setDocsDoRecorte(chave);
    });
  }, [periodFilter, rodarDocs]);

  const loadDashboard = useCallback(async () => {
    await rodarDash(async () => { setDashboard(await fiscalService.getDashboard()); });
  }, [rodarDash]);

  /** MHemann: a declaração é de UM mês, e o modal só mostra a resposta DESTE pedido. */
  const abrirDeclaracao = useCallback(async () => {
    const { mes, motivo } = mesDaDeclaracao(periodFilter);
    setShowFustModal(true);
    if (!mes) { setFust({ mes: null, motivo, dados: null, erro: null, carregando: false }); return; }
    setFust({ mes, motivo: null, dados: null, erro: null, carregando: true });
    try {
      const dados = await fiscalService.getFustFunttelSummary(mes);
      setFust((f) => (f && f.mes === mes ? { ...f, dados, carregando: false } : f));
    } catch (e) {
      setFust((f) => (f && f.mes === mes ? { ...f, erro: mensagemDoErroDeCarga(e), carregando: false } : f));
    }
  }, [periodFilter]);

  const loadSefazStatus = useCallback(async () => {
    try {
      setSefazStatus(await fiscalService.sefazStatus());
      setSefazErro(null);
    } catch (e) {
      // Desconhecido é "—", nunca "Online": o cartão lia `online !== false`.
      setSefazStatus(null);
      setSefazErro(mensagemDoErroDeCarga(e));
    }
  }, []);

  const loadCertInfo = useCallback(async () => {
    try {
      setCertInfo(await certificateService.getActiveInfo());
      setCertInfoErro(null);
    } catch (e) {
      setCertInfo(null);
      setCertInfoErro(mensagemDoErroDeCarga(e));
    }
  }, []);

  const loadCertificates = useCallback(async () => {
    await rodarCerts(async () => {
      const data = await certificateService.getAll();
      setCertificates(Array.isArray(data) ? data : []);
    });
  }, [rodarCerts]);

  const loadMonitoring = useCallback(async () => {
    setMonitoringLoading(true);
    const periodo = monitoringPeriod;
    await rodarMon(async () => {
      const data = await fiscalService.getMonitoring(periodo);
      setMonitoring(data);
      setMonitoramentoDe(periodo);
    });
    setMonitoringLoading(false);
  }, [monitoringPeriod, rodarMon]);

  const loadAll = useCallback(async () => {
    setLoading(true);
    await Promise.all([loadDocuments(), loadDashboard(), loadSefazStatus(), loadCertInfo()]);
    setLoading(false);
  }, [loadDocuments, loadDashboard, loadSefazStatus, loadCertInfo]);

  useEffect(() => { loadAll(); }, [loadAll]);

  // Recarga do botão "Atualizar": traz a LISTA e os CONTADORES juntos (o
  // dashboard do topo tem endpoint próprio; antes o botão só refazia a lista e
  // os cards do topo ficavam com o número velho, o que fazia a tela parecer
  // travada). `refreshingDocs` alimenta o spinner do PeriodSelector.
  const [refreshingDocs, setRefreshingDocs] = useState(false);
  const refreshDocuments = useCallback(async () => {
    setRefreshingDocs(true);
    try {
      await Promise.all([loadDocuments(), loadDashboard()]);
    } finally {
      setRefreshingDocs(false);
    }
  }, [loadDocuments, loadDashboard]);

  // Emissão fiscal é assíncrona: "Rascunho" vira "Processando" (cron de 30min ou
  // botão de transmitir) e "Processando" vira "Autorizada" quando a SEFAZ
  // responde (verificador de 5min). Sem polling o operador ficava recarregando a
  // página inteira pra ver o lote andar (medido 02/09/2026, 251 notas). Só roda
  // na aba de documentos e enquanto houver algo em trânsito.
  const temDocEmTransito = documents.some(
    (d) => d?.status === 'Rascunho' || d?.status === 'Processando',
  );
  useEffect(() => {
    if (activeTab !== 'documents' || !temDocEmTransito) return;
    const id = setInterval(() => {
      // Não atropela uma recarga manual nem uma transmissão em andamento.
      if (!refreshingDocs && !batchLoading) refreshDocuments();
    }, 20000);
    return () => clearInterval(id);
  }, [activeTab, temDocEmTransito, refreshingDocs, batchLoading, refreshDocuments]);

  // D3: as duas seleções zeram ao trocar filtro, período ou busca. A de transmitir sobrevivia, e o lote levava linhas
  // que não estavam mais na tela.
  useEffect(() => {
    setDownloadIds(new Set());
    setSelectedIds([]);
    setLastClickedIdx(null);
  }, [filterType, filterStatus, periodFilter, search]);

  useEffect(() => {
    if (activeTab === 'certificates') loadCertificates();
  }, [activeTab, loadCertificates]);

  useEffect(() => {
    if (activeTab === 'monitoring') {
      loadMonitoring();
      const interval = setInterval(loadMonitoring, 60000);
      return () => clearInterval(interval);
    }
  }, [activeTab, loadMonitoring]);

  // Carregar motivos de cancelamento quando abrir modal
  useEffect(() => {
    if (cancelDoc && cancelReasonsList.length === 0) {
      // A falha calava (arrow sem chaves, a forma que a catraca não vê) e o select ficava só com "Selecione…": o
      // cancelamento ficava impossível sem dizer por quê. Agora diz, e o "Outro" (texto livre) continua de pé.
      fiscalService.getCancellationReasons()
        .then(data => { setCancelReasonsList(data); setMotivosErro(null); })
        .catch(err => setMotivosErro(mensagemDoErroDeCarga(err)));
    }
  }, [cancelDoc, cancelReasonsList.length]);

  const listaDoRecorte = docsDoRecorte === chaveDoRecorte;
  /** O que a tela pode mostrar e contar: a lista do recorte de agora, nunca a de outro. */
  const docsDaTela = listaDoRecorte ? documents : [];
  // Filter documents by search
  const filtered = docsDaTela.filter((doc: any) => {
    if (!passaNoTipo(doc, filterType) || !passaNoStatus(doc.status, filterStatus)) return false;
    if (!search) return true;
    const s = search.toLowerCase();
    const clientName = [doc.client?.name, doc.client?.companyName].filter(Boolean).join(' ').toLowerCase();
    const invoiceCode = (doc.invoice?.code || '').toLowerCase();
    const docNumber = (doc.documentNumber || '').toLowerCase();
    return clientName.includes(s) || invoiceCode.includes(s) || docNumber.includes(s);
  });

  // Actions
  const handleTransmit = async (doc: any) => {
    setActionLoading(doc.id);
    try {
      if (doc.type === 'nfse') {
        await fiscalService.transmitNfse(doc.id);
      } else {
        await fiscalService.transmitNfcom(doc.id);
      }
      showToast('Documento enviado para transmissao', 'success');
      await loadAll();
    } catch (err: any) {
      showToast(err.response?.data?.message || 'Erro ao transmitir', 'error');
    }
    setActionLoading(null);
  };

  const handleRetry = async (doc: any) => {
    setActionLoading(doc.id);
    try {
      if (doc.type === 'nfse') {
        await fiscalService.retryNfse(doc.id);
      } else {
        await fiscalService.retryNfcom(doc.id);
      }
      showToast('Retransmissao iniciada', 'success');
      await loadAll();
    } catch (err: any) {
      showToast(err.response?.data?.message || 'Erro ao retransmitir', 'error');
    }
    setActionLoading(null);
  };

  const handleDeleteDocument = async (doc: any) => {
    if (!await confirmarPerigo(`Tem certeza que deseja excluir este documento fiscal ${doc.type.toUpperCase()} ${doc.status}?\n\nSó documentos em Rascunho, Erro ou Rejeitado podem ser excluídos, e nenhum deles foi autorizado: nada muda na prefeitura nem na SEFAZ, o registro sai só do HUB.`)) return;
    setActionLoading(doc.id);
    try {
      await fiscalService.delete(doc.id);
      showToast('Documento fiscal excluido', 'success');
      await loadAll();
    } catch (err: any) {
      showToast(err.response?.data?.message || 'Erro ao excluir documento', 'error');
    }
    setActionLoading(null);
  };

  const handleCancel = async () => {
    if (!cancelDoc || !cancelReason.trim()) return;
    setActionLoading(cancelDoc.id);
    try {
      if (cancelDoc.type === 'nfse') {
        await fiscalService.cancelNfse(cancelDoc.id, cancelReason);
      } else {
        await fiscalService.cancelNfcom(cancelDoc.id, cancelReason);
      }
      showToast('Cancelamento solicitado', 'success');
      setCancelDoc(null);
      setCancelReason('');
      await loadAll();
    } catch (err: any) {
      showToast(err.response?.data?.message || 'Erro ao cancelar', 'error');
    }
    setActionLoading(null);
  };

  const handleDownloadPdf = async (doc: any) => {
    try {
      let data;
      if (doc.type === 'nfse') {
        data = await fiscalService.downloadNfsePdf(doc.id);
      } else {
        data = await fiscalService.downloadNfcomPdf(doc.id);
      }
      if (data.url) {
        window.open(data.url, '_blank');
      }
    } catch (err: any) {
      showToast(err.response?.data?.message || 'Erro ao baixar PDF', 'error');
    }
  };

  const handleCheckStatus = async (doc: any) => {
    setActionLoading(doc.id);
    try {
      let result;
      if (doc.type === 'nfse') {
        result = await fiscalService.checkNfseStatus(doc.id);
      } else {
        result = await fiscalService.checkNfcomStatus(doc.id);
      }
      showToast(`Status atualizado: ${result.status}`, result.status === 'Autorizada' ? 'success' : 'info');
      await loadDocuments();
    } catch (err: any) {
      showToast(err.response?.data?.message || 'Erro ao verificar status', 'error');
    }
    setActionLoading(null);
  };

  const handleBatchTransmit = async () => {
    const lote = notasParaTransmitir(filtered, selectedIds);
    if (lote.length === 0) return;
    setBatchLoading(true);
    try {
      const nfseIds = lote.filter(d => d.type === 'nfse').map(d => d.id);
      const nfcomIds = lote.filter(d => d.type === 'nfcom').map(d => d.id);
      let success = 0;
      const errors: Array<{ id: number; error: string }> = [];
      // ⛔ EM BLOCOS (02/09/2026, 130 notas): o backend transmite de 5 em 5 com
      // 4s de pausa (limite da Focus), então um lote grande segura a resposta
      // por minutos e o navegador desiste antes — a tela mostrava "Erro na
      // transmissão em lote" com o servidor ainda transmitindo, e o lote NFCom
      // (disparado DEPOIS do NFS-e) nunca chegava a sair. 20 por requisição dá
      // ~16s por bloco, com progresso na tela e sem timeout.
      const CHUNK = 20;
      const total = nfseIds.length + nfcomIds.length;
      let enviadosAteAgora = 0;
      const transmitirEmBlocos = async (
        ids: number[],
        fn: (chunk: number[]) => Promise<any>,
      ) => {
        for (let i = 0; i < ids.length; i += CHUNK) {
          const chunk = ids.slice(i, i + CHUNK);
          setBatchProgress({ done: enviadosAteAgora, total });
          try {
            const r = await fn(chunk);
            success += r?.success || 0;
            errors.push(...(r?.errors || []));
          } catch (err: any) {
            // Um bloco que falha não pode abortar os demais: a maioria das notas
            // ainda vai. O motivo aparece no resumo final.
            errors.push({ id: chunk[0], error: err?.response?.data?.message || err?.message || 'falha no bloco' });
          }
          enviadosAteAgora += chunk.length;
          setBatchProgress({ done: enviadosAteAgora, total });
        }
      };
      if (nfseIds.length > 0) await transmitirEmBlocos(nfseIds, fiscalService.transmitNfseBatch);
      if (nfcomIds.length > 0) await transmitirEmBlocos(nfcomIds, fiscalService.transmitNfcomBatch);
      if (errors.length === 0) {
        showToast(`${success} documento(s) enviado(s) para transmissao`, 'success');
      } else {
        const docLabel = (id: number) => {
          const doc = lote.find(d => d.id === id);
          if (!doc) return `#${id}`;
          const who = doc.client?.name?.trim() || doc.client?.companyName || doc.invoice?.code || `#${id}`;
          return `${doc.type === 'nfse' ? 'NFS-e' : 'NFCom'} ${who}`;
        };
        const detail = errors.slice(0, 3)
          .map(e => `${docLabel(e.id)}: ${e.error}`.slice(0, 140))
          .join(' • ');
        showToast(
          `${success} transmitida(s), ${errors.length} com erro — ${detail}${errors.length > 3 ? ` (+${errors.length - 3} outros)` : ''}`,
          'error',
        );
      }
      setSelectedIds([]);
      await loadAll();
    } catch (err: any) {
      showToast(err.response?.data?.message || 'Erro na transmissao em lote', 'error');
    }
    setBatchProgress(null);
    setBatchLoading(false);
  };

  const handleExportExcel = async () => {
    if (exportacao.excel) return;
    setExcelExporting(true);
    try {
      const ep = periodToParams(periodFilter);
      const blob = await fiscalService.exportExcel(
        tipoNoServidor(filterType) || undefined,
        filterStatus || undefined,
        ep.month || undefined,
      );
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Documentos_Fiscais_${periodFilter.months.length > 0 ? periodFilter.months.join('_') : 'todos'}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      showToast('Planilha exportada com sucesso', 'success');
    } catch (e) {
      showToast(await apiErrorMessage(e, 'Erro ao exportar Excel'), 'error');
    }
    setExcelExporting(false);
  };

  const handleUploadCert = async () => {
    if (!uploadFile) return;
    setActionLoading(-1);
    try {
      const formData = new FormData();
      formData.append('file', uploadFile);
      formData.append('passphrase', uploadPassword);
      formData.append('type', uploadType);
      if (uploadName) formData.append('name', uploadName);
      await certificateService.upload(formData);
      showToast('Certificado enviado com sucesso', 'success');
      setShowUploadCert(false);
      setUploadFile(null);
      setUploadPassword('');
      setUploadName('');
      setUploadType('empresa');
      await loadCertificates();
      await loadCertInfo();
    } catch (err: any) {
      showToast(err.response?.data?.message || 'Erro ao enviar certificado', 'error');
    }
    setActionLoading(null);
  };

  const handleDeleteCert = async (cert: any) => {
    if (!await confirmarPerigo(confirmacaoDeExcluirCertificado(cert))) return;
    try {
      await certificateService.delete(cert.id);
      showToast('Certificado excluido', 'success');
      await loadCertificates();
      await loadCertInfo();
    } catch (err: any) {
      showToast(err.response?.data?.message || 'Erro ao excluir certificado', 'error');
    }
  };

  const toggleSelect = (id: number) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const toggleSelectAll = () => {
    const transmittable = filtered.filter(d => d.status === 'Rascunho' || d.status === 'Erro').map(d => d.id);
    if (transmittable.every(id => selectedIds.includes(id))) {
      setSelectedIds(prev => prev.filter(id => !transmittable.includes(id)));
    } else {
      setSelectedIds(prev => Array.from(new Set([...prev, ...transmittable])));
    }
  };

  const isDownloadable = (doc: any) => !!doc.pdfS3Key;

  const handleRowClick = (e: React.MouseEvent, doc: any, idx: number) => {
    if ((e.target as HTMLElement).closest('button,input,a')) return;
    if (!isDownloadable(doc)) return;
    setDownloadIds(prev => {
      const next = new Set(prev);
      if (e.shiftKey && lastClickedIdx !== null) {
        const [start, end] = [Math.min(lastClickedIdx, idx), Math.max(lastClickedIdx, idx)];
        for (let i = start; i <= end; i++) {
          if (isDownloadable(filtered[i])) next.add(filtered[i].id);
        }
      } else {
        next.has(doc.id) ? next.delete(doc.id) : next.add(doc.id);
      }
      return next;
    });
    setLastClickedIdx(idx);
  };

  const toggleDownloadSelect = (id: number) => {
    setDownloadIds(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleDownloadAll = () => {
    const downloadable = filtered.filter(isDownloadable);
    const allSel = downloadable.length > 0 && downloadable.every(d => downloadIds.has(d.id));
    setDownloadIds(allSel ? new Set() : new Set(downloadable.map(d => d.id)));
  };

  const handleBatchDownloadPdf = async () => {
    if (downloadIds.size === 0) return;
    setZipLoading(true);
    try {
      await fiscalService.downloadZip(Array.from(downloadIds));
      showToast(`${downloadIds.size} PDF(s) baixado(s) como ZIP`, 'success');
      setDownloadIds(new Set());
    } catch (err: any) {
      showToast(await apiErrorMessage(err, 'Erro ao baixar ZIP'), 'error');
    }
    setZipLoading(false);
  };

  const handleBatchDownloadXml = async () => {
    if (downloadIds.size === 0) return;
    setXmlBatchLoading(true);
    let okCount = 0, failCount = 0;
    for (const id of Array.from(downloadIds)) {
      try { await fiscalService.downloadXml(id); okCount++; } catch { failCount++; }
    }
    showToast(failCount ? `${okCount} XML(s) baixado(s), ${failCount} sem XML disponível` : `${okCount} XML(s) baixado(s)`, failCount ? 'error' : 'success');
    setXmlBatchLoading(false);
  };

  const handleDownloadXml = async (doc: any) => {
    setXmlLoadingId(doc.id);
    try {
      await fiscalService.downloadXml(doc.id);
      showToast('XML baixado', 'success');
    } catch (err: any) {
      showToast(await apiErrorMessage(err, 'Erro ao baixar XML'), 'error');
    }
    setXmlLoadingId(null);
  };

  const handleDownloadXmlZip = async (type: 'nfse' | 'nfcom' | 'all') => {
    // Um mês, o da tela. Antes: vários meses viravam o texto "2026-08,2026-09" (e o servidor dizia "Nenhum documento
    // com XML"); por datas, ia o mês CORRENTE.
    const month = exportacao.mesDoZip;
    if (!month) return;
    setXmlZipLoading(true);
    try {
      await fiscalService.downloadXmlZip(month, type);
      const label = type === 'all' ? 'Todos XMLs' : type === 'nfse' ? 'XMLs NFS-e' : 'XMLs NFCom';
      showToast(`${label} de ${month} baixado(s) com sucesso`, 'success');
    } catch (err: any) {
      showToast(await apiErrorMessage(err, 'Erro ao baixar XMLs'), 'error');
    }
    setXmlZipLoading(false);
  };

  const exportacaoPeloPeriodo = exportacaoDoPeriodo(periodFilter);
  // O Excel sai do servidor, que recorta por UM tipo e UM status: o ambiente e os grupos dos cartões não chegam lá, e a
  // planilha sairia maior que a lista. Trava com o motivo, como as travas do período.
  const exportacao = {
    ...exportacaoPeloPeriodo,
    excel: exportacaoPeloPeriodo.excel
      || (filterType.startsWith('nfse-') ? 'A planilha não separa NFS-e nacional de municipal: escolha NFS-e no tipo para exportar.' : null)
      || (filterStatus in GRUPOS_DE_STATUS ? 'A planilha sai por um status de cada vez: escolha o status para exportar.' : null),
  };
  const loteVisivel = notasParaTransmitir(filtered, selectedIds);
  /** Cartão de contagem: o número é do recorte da tela, ou "—". Nunca 0 de uma lista que não chegou. */
  const contar = (pred: (d: any) => boolean) => (listaDoRecorte ? docsDaTela.filter(pred).length : textos.numeroSemFonte);

  const getClientName = (doc: any) => {
    return doc.client?.name?.trim() || doc.client?.companyName || '-';
  };

  // Só a PRIMEIRA carga ocupa a tela. O loadAll roda depois de cada transmitir, cancelar e excluir, e trocava a
  // tela inteira pelo spinner a cada ação; a lista que já está na tela fica (o EstadoDaLista diz se a recarga falhou).
  if (loading && docsDoRecorte === null && cargaDocs.estado !== 'erro') {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
        <span className="ml-3 text-slate-400">Carregando dados fiscais...</span>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      {/* Dashboard Cards - only on documents/certificates */}
      {activeTab !== 'monitoring' && <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
        {/* Cartões do topo (padrão das listas no Financeiro, 22/10/2026): o CartaoDoTopo. Os filtros ligam/desligam com a
            barra primary no escolhido (saiu o anel laranja); o número é texto, e o data-kpi fica nele. Erros leva a barra
            danger quando há erro, como o "Vencidas" de Recebíveis. */}
        <CartaoDoTopo
          rotulo="NFS-e"
          valor={<span className={listaDoRecorte ? '' : 'text-slate-500'} data-kpi="nfse">{contar((d: any) => d.type === 'nfse')}</span>}
          ativo={filterType === 'nfse'}
          onClick={() => setFilterType(filterType === 'nfse' ? '' : 'nfse')}
        />
        <CartaoDoTopo
          rotulo="NFCom"
          valor={<span className={listaDoRecorte ? '' : 'text-slate-500'} data-kpi="nfcom">{contar((d: any) => d.type === 'nfcom')}</span>}
          ativo={filterType === 'nfcom'}
          onClick={() => setFilterType(filterType === 'nfcom' ? '' : 'nfcom')}
        />
        <CartaoDoTopo
          rotulo="Pendentes"
          valor={<span className={listaDoRecorte ? '' : 'text-slate-500'} data-kpi="pendentes">{contar((d: any) => d.status === 'Rascunho' || d.status === 'Processando')}</span>}
          sub="rascunho e processando"
          ativo={filterStatus === 'pendentes'}
          onClick={() => setFilterStatus(filterStatus === 'pendentes' ? '' : 'pendentes')}
        />
        <CartaoDoTopo
          rotulo="Autorizadas"
          valor={<span className={listaDoRecorte ? '' : 'text-slate-500'} data-kpi="autorizadas">{contar((d: any) => d.status === 'Autorizada')}</span>}
          ativo={filterStatus === 'Autorizada'}
          onClick={() => setFilterStatus(filterStatus === 'Autorizada' ? '' : 'Autorizada')}
        />
        {/* K1: a cancelada ganha cartão. Autorizadas + Canceladas fecha com NFS-e + NFCom quando nada está pendente. */}
        <CartaoDoTopo
          rotulo="Canceladas"
          valor={<span className={listaDoRecorte ? '' : 'text-slate-500'} data-kpi="canceladas">{contar((d: any) => d.status === 'Cancelada')}</span>}
          ativo={filterStatus === 'Cancelada'}
          onClick={() => setFilterStatus(filterStatus === 'Cancelada' ? '' : 'Cancelada')}
        />
        <CartaoDoTopo
          rotulo="Erros"
          valor={<span className={listaDoRecorte ? '' : 'text-slate-500'} data-kpi="erros">{contar((d: any) => d.status === 'Erro' || d.status === 'Rejeitada')}</span>}
          sub="erro e rejeitada"
          ativo={filterStatus === 'erros'}
          barra={listaDoRecorte && documents.some((d: any) => d.status === 'Erro' || d.status === 'Rejeitada') ? 'danger' : null}
          onClick={() => setFilterStatus(filterStatus === 'erros' ? '' : 'erros')}
        />
        <CartaoDoTopo
          rotulo="SEFAZ"
          valor={
            <span
              className={!sefazStatus ? 'text-slate-500' : sefazStatus.online ? '' : TONE_TEXT.danger}
              data-kpi="sefaz"
              title={sefazErro ? `Não consegui consultar a SEFAZ: ${sefazErro}` : undefined}
            >
              {!sefazStatus ? textos.numeroSemFonte : sefazStatus.online ? 'Online' : 'Offline'}
            </span>
          }
          sub={(certInfo || certInfoErro) ? (
            <span data-kpi="cert" title={certInfoErro ? `Não consegui ler o certificado ativo: ${certInfoErro}` : undefined}>
              Cert: {certInfo?.daysUntilExpiry != null ? `${certInfo.daysUntilExpiry}d` : textos.numeroSemFonte}
            </span>
          ) : undefined}
        />
        {/* Sumia quando a carga falhava, e "sem cartão" quer dizer "nada pendente". */}
        {!dashboard && cargaDash.estado === 'erro' && (
          <CartaoDoTopo
            data-kpi="manual-erro"
            role="status"
            rotulo="NF Manual pendente"
            valor={<span className="text-slate-500">{textos.numeroSemFonte}</span>}
            sub={<span className={TONE_TEXT.warning}>Não carregou: {cargaDash.erro}</span>}
          />
        )}
        {(dashboard?.manualPending?.length || 0) > 0 && (
          // O número grande é só o que depende de NÓS. O resto espera o órgão informar o empenho, e contar tudo junto fazia
          // o card gritar 13 quando havia 1 para fazer. A pendência é a barra âmbar.
          <CartaoDoTopo
            rotulo="NF Manual pendente"
            valor={(dashboard.manualPending as any[]).filter(p => p.dono === 'nossa').length}
            sub={<>
              com empenho informado
              {(dashboard.manualPending as any[]).filter(p => p.dono !== 'nossa').length > 0 &&
                ` · ${(dashboard.manualPending as any[]).filter(p => p.dono !== 'nossa').length} aguardando o órgão`}
            </>}
            // A barra segue o número grande (o que depende de nós): com 0 e só o órgão devendo, ela acendia sem ter o que fazer.
            barra={(dashboard.manualPending as any[]).some(p => p.dono === 'nossa') ? 'warning' : null}
            onClick={() => setShowManualPendingModal(true)}
          />
        )}
      </div>}

      {/* NF Manual pendente Modal */}
      {showManualPendingModal && (dashboard?.manualPending?.length || 0) > 0 && (
        // Só leitura: fecha ao clicar fora (como já era).
        <CascaDeModal
          largura="sm"
          fecharAoClicarFora
          titulo="NF Manual pendente"
          subtitulo="Separadas por quem está devendo. Clique para filtrar os documentos da fatura."
          onClose={() => setShowManualPendingModal(false)}
          corpoClassName="p-4 space-y-4"
        >
              {(['nossa', 'aguardando_orgao'] as const).map(dono => {
                const grupo = (dashboard.manualPending as any[]).filter(p => (p.dono || 'aguardando_orgao') === dono);
                if (grupo.length === 0) return null;
                return (
                  <div key={dono}>
                    <p className={`text-[10px] uppercase tracking-wide mb-1.5 ${dono === 'nossa' ? TONE_TEXT.warning : 'text-slate-500'}`}>
                      {dono === 'nossa'
                        ? 'Empenho informado, falta emitir'
                        : 'Aguardando o órgão informar o empenho'}
                    </p>
                    <div className="space-y-2">
                      {grupo.map((pend, i) => (
                        <button
                          key={i}
                          onClick={() => { setSearch(pend.code); setShowManualPendingModal(false); }}
                          className={`w-full text-left bg-slate-900/60 hover:bg-slate-700/50 border rounded-lg px-3 py-2.5 transition-colors ${dono === 'nossa' ? 'border-amber-600/50' : 'border-slate-700'}`}
                        >
                          <div className="flex items-center justify-between gap-2">
                            <span className="font-mono text-sm text-slate-200">{pend.code}</span>
                            <span className={`text-xs whitespace-nowrap ${dono === 'nossa' ? 'text-amber-400' : 'text-slate-400'}`}>
                              emitido R$ {Number(pend.emitted).toFixed(2)} de R$ {Number(pend.total).toFixed(2)}
                            </span>
                          </div>
                          <div className="text-xs text-slate-500 truncate mt-0.5">
                            {pend.client}
                            {pend.empenhoNumber ? ` · empenho ${pend.empenhoNumber}` : ''}
                            {pend.diasComEmpenho != null ? ` · há ${pend.diasComEmpenho} dia(s)` : ''}
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })}
        </CascaDeModal>
      )}

      {/* FUST/FUNTTEL Modal — só leitura: fecha ao clicar fora (como já era). Mostra só a resposta do mês PEDIDO: antes
          abria com o último resumo carregado, e com a carga falhando o "Copiar" levava os números de outro mês para a
          declaração tributária. */}
      {showFustModal && fust && (() => {
        const dados = fust.dados && fust.dados.referenceMonth === fust.mes ? fust.dados : null;
        return (
        <CascaDeModal
          largura="sm"
          fecharAoClicarFora
          titulo="MHemann — Declaração Mensal de Faturamento"
          subtitulo={fust.mes ? `Referência: ${fust.mes}` : 'Sem mês escolhido'}
          onClose={() => setShowFustModal(false)}
          corpoClassName="p-4 space-y-3"
          rodape={dados ? (
            // Copiar não grava: neutro (§8.1).
            <button
              onClick={() => {
                const text = [
                  `MHemann — Declaração Mensal ${dados.referenceMonth}`,
                  `Valor fat: R$ ${dados.nfcom.totalValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
                  `ICMS: R$ 0,00`,
                  `PIS: R$ ${dados.pis.value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
                  `COFINS: R$ ${dados.cofins.value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
                  `STFC-DL Valor: R$ ${dados.nfcom.totalValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
                  `STFC-DL Qtd NFs: ${dados.nfcom.count}`,
                  `ROL Não Telecom: R$ ${dados.nfse.totalValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
                ].join('\n');
                navigator.clipboard.writeText(text);
                setToast({ message: 'Valores copiados!', type: 'success' });
              }}
              className="w-full px-4 py-2 bg-slate-700 hover:bg-slate-600 text-slate-200 rounded-lg text-sm transition-colors"
            >
              Copiar valores para MHemann
            </button>
          ) : undefined}
        >
          {fust.motivo && <p className={`text-sm ${TONE_TEXT.warning}`} data-testid="fust-estado">{fust.motivo}</p>}
          {fust.carregando && <p className="text-sm text-slate-400" data-testid="fust-estado">{textos.carregando(`a declaração de ${fust.mes}`)}</p>}
          {fust.erro && (
            <div role="alert" className={`text-sm ${TONE_TEXT.danger}`} data-testid="fust-estado">
              {textos.naoConseguiCarregar(`a declaração de ${fust.mes}`)} {fust.erro}.
            </div>
          )}
          {dados && (<>
              {/* Telecom (NFCom) */}
              <div className="bg-slate-700/30 rounded-lg p-3">
                <div className="text-xs text-slate-500 uppercase mb-2">STFC-DL (Telecom)</div>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div><span className="text-slate-400">Valor fat:</span> <span className="text-white font-medium">R$ {dados.nfcom.totalValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></div>
                  <div><span className="text-slate-400">Qtd NFs:</span> <span className="text-white font-medium">{dados.nfcom.count}</span></div>
                </div>
              </div>

              {/* Tributos */}
              <div className="bg-slate-700/30 rounded-lg p-3">
                <div className="text-xs text-slate-500 uppercase mb-2">Tributos</div>
                <div className="space-y-1.5 text-sm">
                  <div className="flex justify-between"><span className="text-slate-400">ICMS:</span> <span className="text-white">R$ 0,00 <span className="text-slate-500 text-xs">(Simples Nacional)</span></span></div>
                  <div className="flex justify-between"><span className="text-slate-400">PIS ({dados.pis.rate}%):</span> <span className="text-white">R$ {dados.pis.value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></div>
                  <div className="flex justify-between"><span className="text-slate-400">COFINS ({dados.cofins.rate}%):</span> <span className="text-white">R$ {dados.cofins.value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></div>
                  <div className="border-t border-slate-600 pt-1.5 flex justify-between"><span className="text-slate-400">FUST ({dados.fust.rate}%):</span> <span className="text-white font-semibold">R$ {dados.fust.value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></div>
                  <div className="flex justify-between"><span className="text-slate-400">FUNTTEL ({dados.funttel.rate}%):</span> <span className="text-white font-semibold">R$ {dados.funttel.value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></div>
                </div>
              </div>

              {/* Não Telecom (NFS-e) */}
              <div className="bg-slate-700/30 rounded-lg p-3">
                <div className="text-xs text-slate-500 uppercase mb-2">ROL Receitas NÃO Telecom</div>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div><span className="text-slate-400">Valor:</span> <span className="text-white font-medium">R$ {dados.nfse.totalValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span></div>
                  <div><span className="text-slate-400">Qtd NFs:</span> <span className="text-white font-medium">{dados.nfse.count}</span></div>
                </div>
              </div>
          </>)}
        </CascaDeModal>
        );
      })()}

      {/* === TAB: Documentos Fiscais === */}
      {activeTab === 'documents' && (
        <div className="space-y-4">
          <ListToolbar
            period={
              <PeriodSelector
                value={periodFilter}
                onChange={setPeriodFilter}
                onRefresh={() => refreshDocuments()}
                refreshing={refreshingDocs}
              />
            }
            filters={<>
            <select
              value={filterType}
              onChange={e => setFilterType(e.target.value)}
              className={`px-3 py-2 ${campo} rounded-lg text-sm focus:outline-none`}
            >
              <option value="">Todos os tipos</option>
              {/* A2: a NFS-e dos dois ambientes, e cada um separado (o mês da virada tem os dois). */}
              {TIPOS_DA_LISTA.map((t) => <option key={t.valor} value={t.valor}>{t.rotulo}</option>)}
            </select>
            <select
              value={filterStatus}
              onChange={e => setFilterStatus(e.target.value)}
              className={`px-3 py-2 ${campo} rounded-lg text-sm focus:outline-none`}
            >
              <option value="">Todos os status</option>
              {/* Do mapa único (os seis) e os dois grupos que os cartões Pendentes e Erros abrem. */}
              {STATUS_DA_NOTA.map((st) => <option key={st} value={st}>{st}</option>)}
              {(Object.keys(GRUPOS_DE_STATUS) as GrupoDeStatus[]).map((g) => <option key={g} value={g}>{GRUPOS_DE_STATUS[g].rotulo}</option>)}
            </select>
            </>}
            search={<ToolbarSearch value={search} onChange={setSearch} placeholder="Buscar por cliente, fatura ou número..." />}
            actions={<>
            {/* M1 (03/11/2026): a declaração do MHemann é AÇÃO, e mora com as ações. Como cartão, ela disputava atenção com
                Erros e Pendentes sem dizer nada da lista. */}
            <button
              type="button"
              onClick={abrirDeclaracao}
              data-acao="mhemann"
              className="px-3 py-2 text-sm text-slate-300 bg-central-cartao border border-central-borda hover:bg-central-elevado rounded-lg whitespace-nowrap"
              title="Declaração Mensal de Faturamento do MHemann"
            >
              Declaração MHemann
            </button>
            {/* Download XML ZIP: o menu é o MaisAcoes com rótulo (como o "Exportar" das Faturas), sem o fundo
                fundo de tela inteira montado à mão. Fora do recorte aceito (D5), os itens ficam travados com o motivo; a frase
                visível fica na segunda linha da barra. */}
            <div data-exportar="zip">
              <MaisAcoes
                rotulo={xmlZipLoading ? 'Baixando...' : 'XMLs'}
                title={exportacao.zip || `Baixar os XMLs de ${exportacao.mesDoZip}`}
                itens={[
                  { label: 'Todos (NFS-e + NFCom)', onClick: () => handleDownloadXmlZip('all'), disabled: xmlZipLoading || !!exportacao.zip, title: exportacao.zip || undefined },
                  { label: 'Apenas NFS-e', onClick: () => handleDownloadXmlZip('nfse'), disabled: xmlZipLoading || !!exportacao.zip, title: exportacao.zip || undefined },
                  { label: 'Apenas NFCom', onClick: () => handleDownloadXmlZip('nfcom'), disabled: xmlZipLoading || !!exportacao.zip, title: exportacao.zip || undefined },
                ]}
              />
            </div>
            <button
              onClick={handleExportExcel}
              disabled={excelExporting || !!exportacao.excel}
              data-exportar="excel"
              className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
              title={exportacao.excel || 'Exportar Excel'}
            >
              {excelExporting ? (
                <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>
              ) : (
                <Icon name="download" className="w-5 h-5" />
              )}
            </button>
            </>}
            secondRow={<>
            {/* A frase da trava fica VISÍVEL (não só no title): o botão cinza sem explicação parece quebrado. */}
            {(exportacao.excel || exportacao.zip) && (
              <span className={`text-xs ${TONE_TEXT.warning}`} data-testid="exportacao-travada">{exportacao.excel || exportacao.zip}</span>
            )}
            {downloadIds.size > 0 && (
              <button
                onClick={handleBatchDownloadPdf}
                disabled={zipLoading}
                className="px-4 py-2 bg-primary hover:bg-primary-strong text-white rounded-lg text-sm font-medium disabled:opacity-50"
              >
                {zipLoading ? 'Baixando...' : `Baixar ${downloadIds.size} PDF(s)`}
              </button>
            )}
            {downloadIds.size > 0 && (
              <button
                onClick={handleBatchDownloadXml}
                disabled={xmlBatchLoading}
                className="px-4 py-2 bg-slate-700 hover:bg-slate-600 text-slate-300 rounded-lg text-sm font-medium disabled:opacity-50"
              >
                {xmlBatchLoading ? 'Baixando...' : `Baixar ${downloadIds.size} XML(s)`}
              </button>
            )}
            {loteVisivel.length > 0 && (
              <button
                onClick={handleBatchTransmit}
                disabled={batchLoading}
                className="px-4 py-2 bg-primary hover:bg-primary-strong text-white rounded-lg text-sm font-medium disabled:opacity-50"
              >
                {batchLoading
                  ? batchProgress
                    ? `Transmitindo ${batchProgress.done}/${batchProgress.total}...`
                    : 'Transmitindo...'
                  : `Transmitir ${loteVisivel.length} selecionado(s)`}
              </button>
            )}
            </>}
          />

          {/* Table. Com o recorte trocado e a lista dele ainda não lida, a carga é tratada como "sem dados": carregando,
              ou "não carreguei <período>" se falhou. Nunca a lista de outro recorte, nem "Nenhum documento fiscal". */}
          <EstadoDaLista
            carga={listaDoRecorte ? cargaDocs : { ...cargaDocs, estado: cargaDocs.estado === 'erro' ? 'erro' : 'carregando', atualizadoEm: null }}
            temDados={listaDoRecorte}
            oQue={`os documentos fiscais de ${rotuloDoRecorte(periodFilter)}`}
            onTentarDeNovo={() => refreshDocuments()}
            vazio={A_PROPRIA_LISTA_DIZ_O_VAZIO}
          >
          {/* A casca das listas, SEM overflow de rolagem: o cabeçalho fixa no <main>, e o ⋯ é fixo. */}
          <CascaDaLista>
              <TabelaDaLista>
                <CabecalhoDaLista>
                    <ColunaDaLista largura="w-12" rotulo={
                      filtered.some(d => d.status === 'Rascunho' || d.status === 'Erro') ? (
                        <input
                          type="checkbox"
                          onChange={toggleSelectAll}
                          checked={filtered.filter(d => d.status === 'Rascunho' || d.status === 'Erro').length > 0 &&
                            filtered.filter(d => d.status === 'Rascunho' || d.status === 'Erro').every(d => selectedIds.includes(d.id))}
                          className="rounded border-slate-600"
                          title="Selecionar para transmissao"
                        />
                      ) : (
                        <input
                          type="checkbox"
                          onChange={toggleDownloadAll}
                          checked={filtered.filter(isDownloadable).length > 0 &&
                            filtered.filter(isDownloadable).every(d => downloadIds.has(d.id))}
                          className="rounded border-slate-600"
                          title="Selecionar para download"
                        />
                      )} />
                    <ColunaDaLista rotulo="Tipo" largura="w-24" />
                    <ColunaDaLista rotulo="Fatura" largura="w-40" />
                    <ColunaDaLista rotulo="Cliente" />
                    <ColunaDaLista rotulo="Ref." largura="w-32" />
                    <ColunaDaLista rotulo="Valor" largura="w-32" alinhamento="direita" />
                    <ColunaDaLista rotulo="Status" largura="w-32" />
                    <ColunaDaLista rotulo="N. Doc" largura="w-28" />
                    <ColunaDaLista rotulo={<span className="sr-only">Ações</span>} largura="w-48" />
                </CabecalhoDaLista>
                <tbody className="divide-y divide-slate-800">
                  {filtered.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="py-16">
                        <div className="flex flex-col items-center justify-center text-center">
                          <div className="p-4 bg-slate-700/50 rounded-full mb-4">
                            <svg className="w-8 h-8 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
                          </div>
                          <p className="text-slate-400 font-medium">Nenhum documento fiscal</p>
                          <p className="text-slate-500 text-sm mt-1">Crie documentos a partir das faturas</p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    filtered.map((doc: any, idx: number) => {
                      // D1: o verbo do estado à vista (transmitir, retransmitir, verificar, ou o PDF da autorizada); o resto no ⋯,
                      // com o Excluir e o Cancelar (sem volta) em perigo e separados.
                      const verbo = doc.status === 'Rascunho'
                        ? { rotulo: 'Transmitir', onClick: () => handleTransmit(doc), desabilitado: actionLoading === doc.id }
                        : doc.status === 'Erro' || doc.status === 'Rejeitada'
                          ? { rotulo: 'Retransmitir', onClick: () => handleRetry(doc), desabilitado: actionLoading === doc.id }
                          : doc.status === 'Processando'
                            ? { rotulo: 'Verificar status', onClick: () => handleCheckStatus(doc), desabilitado: actionLoading === doc.id }
                            : doc.status === 'Autorizada'
                              ? { rotulo: 'PDF', onClick: () => handleDownloadPdf(doc), title: 'Download PDF' }
                              : undefined;
                      const itens = [
                        { label: 'Detalhes', title: 'Detalhes', onClick: () => setDetailDoc(doc) },
                        // XML fica disponível também na nota CANCELADA: o cancelamento não apaga o XML autorizado, e a
                        // contabilidade do cliente costuma pedir ele.
                        ...(doc.xmlAuthorizedS3Key ? [{ label: xmlLoadingId === doc.id ? 'Baixando XML…' : 'Baixar XML', onClick: () => handleDownloadXml(doc), disabled: xmlLoadingId === doc.id, title: 'Baixar XML desta nota' }] : []),
                        ...(doc.status === 'Autorizada' ? [{
                          label: 'Cancelar nota',
                          title: 'Cancelar',
                          danger: true,
                          separadoAntes: true,
                          onClick: () => { setCancelDoc(doc); setCancelReason(''); setSelectedReasonId(''); setCustomReason(''); },
                        }] : []),
                        ...((doc.status === 'Rascunho' || doc.status === 'Erro') ? [{ label: 'Excluir', onClick: () => handleDeleteDocument(doc), disabled: actionLoading === doc.id, danger: true, separadoAntes: true }] : []),
                      ];
                      const nome = doc.client?.name?.trim() || doc.client?.companyName || '-';
                      return (
                      <LinhaDaLista
                        key={doc.id}
                        destacada={downloadIds.has(doc.id)}
                        className={isDownloadable(doc) ? 'cursor-pointer' : ''}
                        onClick={(e?: any) => handleRowClick(e, doc, idx)}
                      >
                        <td className={CELULA}>
                          {(doc.status === 'Rascunho' || doc.status === 'Erro') ? (
                            <input
                              type="checkbox"
                              checked={selectedIds.includes(doc.id)}
                              onChange={() => toggleSelect(doc.id)}
                              className="rounded border-slate-600"
                              title="Selecionar para transmissao"
                            />
                          ) : isDownloadable(doc) ? (
                            <input
                              type="checkbox"
                              checked={downloadIds.has(doc.id)}
                              onChange={() => toggleDownloadSelect(doc.id)}
                              className="rounded border-slate-600"
                              title="Selecionar para download"
                            />
                          ) : null}
                        </td>
                        <td className={CELULA}>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${typeColors[doc.type] || 'bg-slate-500/20 text-slate-300'}`}>
                            {typeLabels[doc.type] || doc.type}
                          </span>
                          {/* A2: o ambiente nas duas formas, para ninguém precisar saber que nulo é municipal. */}
                          {ambienteDaNota(doc) && <span className="block mt-1 text-[11px] text-slate-500" data-ambiente={ambienteDaNota(doc)!}>{ambienteDaNota(doc)}</span>}
                        </td>
                        <td className={`${CELULA} text-sm text-slate-300`}>{doc.invoice?.code || '-'}</td>
                        {/* C1: o nome (que abre o popover do cliente) e UMA sub-linha, razão · CNPJ. */}
                        <CelulaCliente
                          nome={<ClientPopover clientId={doc.client?.id}>{nome}</ClientPopover>}
                          razao={doc.client?.companyName && doc.client.companyName !== nome ? doc.client.companyName : null}
                          cnpj={doc.client?.cnpj}
                        />
                        <td className={`${CELULA} text-sm text-slate-400`}>
                          {doc.referenceMonth || doc.invoice?.referenceMonth || '-'}
                          {doc.invoice?.referenceMonth && doc.referenceMonth && doc.referenceMonth !== doc.invoice.referenceMonth && doc.status === 'Autorizada' && (
                            <span className={`ml-1.5 px-1.5 py-0.5 text-[10px] font-medium rounded ${TONE_BADGE.warning}`} title={`Substituição - competência original: ${doc.invoice.referenceMonth}`}>
                              Ref: {doc.invoice.referenceMonth.split('-').reverse().join('/')}
                            </span>
                          )}
                        </td>
                        <CelulaDinheiro valor={doc.totalValue ?? doc.invoice?.totalValue} />
                        <td className={CELULA}>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${seloDoStatusDaNota(doc.status)}`}>
                            {doc.status}
                          </span>
                        </td>
                        <td className={`${CELULA} text-sm text-slate-300`}>
                          {doc.documentNumber || '-'}
                          {/* Na nacional, o fim da chave: é por ela que se acha a nota no portal, sem abrir o detalhe. */}
                          {ambienteDaNota(doc) === 'nacional' && fimDaChave(doc.accessKey) && (
                            <span className="block text-[11px] text-slate-500 font-mono" title={doc.accessKey} data-fim-da-chave>{fimDaChave(doc.accessKey)}</span>
                          )}
                        </td>
                        <CelulaAcoes rotuloDoMenu={`Mais ações da nota ${doc.documentNumber || doc.invoice?.code || doc.id}`} verbo={verbo} itens={itens} />
                      </LinhaDaLista>
                      );
                    })
                  )}
                </tbody>
              </TabelaDaLista>
          </CascaDaLista>
          </EstadoDaLista>
        </div>
      )}

      {/* === TAB: Certificados === */}
      {activeTab === 'certificates' && (
        <div className="space-y-4">
          {/* Active company cert info */}
          {certInfoErro && (
            <div role="alert" className={`text-sm ${TONE_TEXT.warning}`} data-testid="cert-ativo-erro">
              Não consegui ler o certificado ativo: {certInfoErro}.
            </div>
          )}
          {certInfo && certInfo.active && (
            <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-slate-700/60 flex items-center justify-center">
                  <Icon name="shield" className="w-5 h-5 text-slate-300" />
                </div>
                <div>
                  <h3 className="text-white font-medium">Certificado Fiscal Ativo</h3>
                  <p className="text-xs text-slate-400">Usado para assinar NFS-e e NFCom</p>
                </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                <div>
                  <div className="text-xs text-slate-400">Titular</div>
                  <div className="text-sm text-white font-medium">{certInfo.name || '-'}</div>
                </div>
                <div>
                  <div className="text-xs text-slate-400">CNPJ</div>
                  <div className="text-sm text-white font-mono">{certInfo.cnpj ? certInfo.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : '-'}</div>
                </div>
                <div>
                  <div className="text-xs text-slate-400">Emissao</div>
                  <div className="text-sm text-white">{fmtDate(certInfo.validFrom)}</div>
                </div>
                <div>
                  <div className="text-xs text-slate-400">Validade</div>
                  <div className="text-sm text-white">{fmtDate(certInfo.validUntil || certInfo.validTo)}</div>
                </div>
                <div>
                  <div className="text-xs text-slate-400">Dias restantes</div>
                  <div className={`text-lg font-bold ${(certInfo.daysUntilExpiry ?? 999) < 30 ? 'text-red-400' : (certInfo.daysUntilExpiry ?? 999) < 90 ? 'text-yellow-400' : 'text-white'}`}>
                    {certInfo.daysUntilExpiry != null ? `${certInfo.daysUntilExpiry} dias` : '-'}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Actions. O Upload só com a lista PRONTA: com a lista sem chegar ele ficava ao lado de "Nenhum certificado
              cadastrado", e subir de novo um .pfx desativa o certificado ativo do mesmo CNPJ. */}
          <div className="flex justify-end">
            {cargaCerts.estado === 'pronto' && <button
              onClick={() => setShowUploadCert(true)}
              className="px-4 py-2 bg-primary hover:bg-primary-strong text-white rounded-lg text-sm font-medium flex items-center gap-2"
            >
              <Icon name="upload" className="w-4 h-4" /> Upload Certificado
            </button>}
          </div>

          {/* Certificates list */}
          <EstadoDaLista carga={cargaCerts} temDados={certificates.length > 0} oQue="os certificados" onTentarDeNovo={loadCertificates} vazio={A_PROPRIA_LISTA_DIZ_O_VAZIO}>
          <CascaDaLista>
            <TabelaDaLista>
              <CabecalhoDaLista>
                <ColunaDaLista rotulo="Nome" />
                <ColunaDaLista rotulo="Tipo" largura="w-28" />
                <ColunaDaLista rotulo="CNPJ/CPF" largura="w-48" />
                <ColunaDaLista rotulo="Emissao" largura="w-28" />
                <ColunaDaLista rotulo="Validade" largura="w-32" />
                <ColunaDaLista rotulo="Status" largura="w-28" />
                <ColunaDaLista rotulo={<span className="sr-only">Ações</span>} largura="w-20" />
              </CabecalhoDaLista>
              <tbody className="divide-y divide-slate-800">
                {certificates.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="p-8 text-center text-slate-500">
                      Nenhum certificado cadastrado
                    </td>
                  </tr>
                ) : (
                  certificates.map((cert: any) => {
                    const now = new Date();
                    const validUntil = new Date(cert.validUntil || cert.validTo || cert.expiresAt);
                    const daysLeft = Math.floor((validUntil.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
                    const isExpired = daysLeft <= 0;
                    const isExpiring = daysLeft > 0 && daysLeft <= 30;
                    const doc = cert.cnpj || '';
                    const formattedDoc = doc.length === 14
                      ? doc.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
                      : doc.length === 11
                        ? doc.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
                        : doc;
                    return (
                      <LinhaDaLista key={cert.id} apagada={isExpired}>
                        <td className={`${CELULA} text-sm text-white font-medium truncate`} title={cert.name || cert.subject || ''}>{cert.name || cert.subject || '-'}</td>
                        <td className={CELULA}>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                            cert.type === 'pessoal' ? 'bg-blue-500/20 text-blue-400' : 'bg-purple-500/20 text-purple-400'
                          }`}>
                            {cert.type === 'pessoal' ? 'Pessoal' : 'Empresa'}
                          </span>
                        </td>
                        <td className={`${CELULA} text-sm text-slate-300 font-mono`}>{formattedDoc || '-'}</td>
                        <td className={`${CELULA} text-sm text-slate-300`}>{fmtDate(cert.validFrom)}</td>
                        <td className={CELULA}>
                          <div className="text-sm text-slate-300">{fmtDate(cert.validUntil || cert.validTo || cert.expiresAt)}</div>
                          <div className={`text-xs font-medium ${isExpired ? 'text-red-400' : isExpiring ? 'text-yellow-400' : 'text-slate-500'}`}>
                            {isExpired ? 'Expirado' : `${daysLeft} dias`}
                          </div>
                        </td>
                        <td className={CELULA}>
                          {/* E1: Ativo é o normal, neutro; a cor fica para o que expira. */}
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                            isExpired ? TONE_BADGE.danger
                              : isExpiring ? TONE_BADGE.warning
                                : TONE_BADGE.neutral
                          }`}>
                            {isExpired ? 'Expirado' : isExpiring ? 'Expirando' : cert.isActive ? 'Ativo' : 'Inativo'}
                          </span>
                        </td>
                        {/* D1: a lixeira mora no ⋯, em perigo; a pergunta é a de antes. */}
                        <CelulaAcoes
                          rotuloDoMenu={`Mais ações do certificado ${cert.name || cert.subject || cert.id}`}
                          itens={[{ label: 'Excluir', title: 'Excluir', onClick: () => handleDeleteCert(cert), danger: true }]}
                        />
                      </LinhaDaLista>
                    );
                  })
                )}
              </tbody>
            </TabelaDaLista>
          </CascaDaLista>
          </EstadoDaLista>
        </div>
      )}

      {/* === TAB: Monitoramento === */}
      {activeTab === 'monitoring' && <MonitoringContent monitoring={monitoring} monitoringLoading={monitoringLoading} monitoringPeriod={monitoringPeriod} setMonitoringPeriod={setMonitoringPeriod} loadMonitoring={loadMonitoring} sefazStatus={sefazStatus} certInfo={certInfo} handleRetry={handleRetry} actionLoading={actionLoading} carga={cargaMon} monitoramentoDe={monitoramentoDe} />}

      {/* === MODAL: Detalhes === */}
      {detailDoc && (
        // Só leitura: fecha ao clicar fora (como já era). Tipo e status nos selos,
        // fatura e cliente na linha mono, valor e referência na faixa.
        <CascaDeModal
          largura="md"
          fecharAoClicarFora
          titulo={`Detalhes · ${typeLabels[detailDoc.type] || detailDoc.type} #${detailDoc.id}`}
          subtitulo={`${detailDoc.invoice?.code || '—'} · ${getClientName(detailDoc)}`}
          selos={
            <>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${typeColors[detailDoc.type] || ''}`}>
                {typeLabels[detailDoc.type] || detailDoc.type}
              </span>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${seloDoStatusDaNota(detailDoc.status)}`}>
                {detailDoc.status}
              </span>
            </>
          }
          onClose={() => setDetailDoc(null)}
          faixa={[
            { k: 'Valor total', v: `R$ ${fmt(detailDoc.totalValue ?? detailDoc.invoice?.totalValue)}` },
            { k: 'Referência', v: detailDoc.referenceMonth || detailDoc.invoice?.referenceMonth || '—' },
          ]}
          corpoClassName="p-6 space-y-6"
        >
              {/* Info grid */}
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {detailDoc.documentNumber && (
                  <div>
                    <div className="text-xs text-slate-400">N. Documento</div>
                    <div className="text-sm text-white">{detailDoc.documentNumber}</div>
                  </div>
                )}
                {detailDoc.series && (
                  <div>
                    <div className="text-xs text-slate-400">Serie</div>
                    <div className="text-sm text-white">{detailDoc.series}</div>
                  </div>
                )}
                {ambienteDaNota(detailDoc) && (
                  <div data-detalhe="ambiente">
                    <div className="text-xs text-slate-400">Ambiente</div>
                    <div className="text-sm text-white">{ambienteDaNota(detailDoc) === 'nacional' ? 'NFS-e Nacional' : 'Municipal (prefeitura)'}</div>
                  </div>
                )}
                {detailDoc.accessKey && (
                  <div className="col-span-2 md:col-span-3">
                    <div className="text-xs text-slate-400 flex items-center gap-2">
                      Chave de Acesso
                      <button
                        type="button"
                        onClick={() => {
                          Promise.resolve()
                            .then(() => navigator.clipboard.writeText(detailDoc.accessKey))
                            .then(() => showToast('Chave copiada', 'success'))
                            .catch(() => showToast('Não consegui copiar: selecione a chave e copie à mão.', 'error'));
                        }}
                        className="text-[11px] text-slate-300 underline hover:text-white"
                      >Copiar</button>
                    </div>
                    <div className="text-sm text-white font-mono break-all">{detailDoc.accessKey}</div>
                    {ambienteDaNota(detailDoc) === 'nacional' && <div className="text-[11px] text-slate-500 mt-1">O PDF desta nota é o DANFSe da NFS-e Nacional.</div>}
                  </div>
                )}
                {detailDoc.protocol && (
                  <div>
                    <div className="text-xs text-slate-400">Protocolo</div>
                    <div className="text-sm text-white">{detailDoc.protocol}</div>
                  </div>
                )}
                {detailDoc.authorizedAt && (
                  <div>
                    <div className="text-xs text-slate-400">Data Autorizacao</div>
                    <div className="text-sm text-white">{fmtDateTime(detailDoc.authorizedAt)}</div>
                  </div>
                )}
                {detailDoc.cancelledAt && (
                  <div>
                    <div className="text-xs text-slate-400">Data Cancelamento</div>
                    <div className="text-sm text-white">{fmtDateTime(detailDoc.cancelledAt)}</div>
                  </div>
                )}
              </div>

              {/* Items */}
              {detailDoc.items && detailDoc.items.length > 0 && (
                <div>
                  <h4 className="text-sm font-medium text-slate-300 mb-2">Itens</h4>
                  <div className="bg-central-fundo/50 rounded-lg overflow-hidden">
                    <table className="w-full text-sm">
                      {(() => {
                        const visibleItems = detailDoc.items.filter((item: any) => Number(item.totalValue || 0) - Number(item.discount || 0) > 0);
                        const hasAnyDiscount = visibleItems.some((item: any) => {
                          const gross = Number(item.unitValue || 0) * Number(item.quantity || 1);
                          const net = Number(item.totalValue || 0) - Number(item.discount || 0);
                          return gross > 0 && Math.abs(gross - net) > 0.01;
                        });
                        return (
                          <>
                            <CabecalhoInterno>
                              <tr className="border-b border-central-borda">
                                <th className="p-2 text-left text-xs text-slate-400">#</th>
                                <th className="p-2 text-left text-xs text-slate-400">Item (como sai na nota)</th>
                                <th className="p-2 text-right text-xs text-slate-400">Qtd</th>
                                <th className="p-2 text-right text-xs text-slate-400">Vl. Unit.</th>
                                {hasAnyDiscount && <th className="p-2 text-right text-xs text-slate-400">Desconto</th>}
                                <th className="p-2 text-right text-xs text-slate-400">Total</th>
                              </tr>
                            </CabecalhoInterno>
                            <tbody>
                              {visibleItems.map((item: any, idx: number) => {
                                const gross = Number(item.unitValue || 0) * Number(item.quantity || 1);
                                const net = Number(item.totalValue || 0) - Number(item.discount || 0);
                                const discountValue = gross - net;
                                const discountPct = gross > 0 && discountValue > 0.01 ? (discountValue / gross * 100) : 0;
                                return (
                                  <tr key={idx} className="border-b border-central-borda/50">
                                    <td className="p-2 text-xs text-slate-500">{idx + 1}</td>
                                    {/* O texto como SAI NA NOTA (o name, com o código na NFS-e), em destaque; a descrição embaixo, menor
                                        (16/10/2026: o "— Nota de Empenho nº X" mora no name e ficava escondido). */}
                                    <td className="p-2 text-xs" data-item-na-nota>
                                      <span className="block text-white font-medium">{textoDoItemNaNota(item, detailDoc.type)}</span>
                                      {descricaoAlemDoTexto(item, detailDoc.type) && (
                                        <span className="block text-[11px] text-slate-400 mt-0.5">{descricaoAlemDoTexto(item, detailDoc.type)}</span>
                                      )}
                                    </td>
                                    <td className="p-2 text-xs text-slate-300 text-right">{item.quantity ?? 1}</td>
                                    <td className="p-2 text-xs text-slate-300 text-right">R$ {fmt(item.unitValue)}</td>
                                    {hasAnyDiscount && (
                                      <td className="p-2 text-xs text-right">
                                        {discountPct > 0 ? (
                                          <span className={TONE_TEXT.danger}>-{discountPct % 1 === 0 ? discountPct.toFixed(0) : discountPct.toFixed(1)}%</span>
                                        ) : (
                                          <span className="text-slate-600">—</span>
                                        )}
                                      </td>
                                    )}
                                    <td className="p-2 text-xs text-white text-right font-medium">R$ {fmt(net)}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </>
                        );
                      })()}
                    </table>
                  </div>
                </div>
              )}

              {/* Last error */}
              {detailDoc.lastError && (
                <div>
                  <h4 className={`text-sm font-medium mb-2 ${TONE_TEXT.danger}`}>Último Erro</h4>
                  <div className={`border rounded-lg p-3 ${TONE_SURFACE.danger} ${TONE_BORDER.danger}`}>
                    <p className="text-sm text-slate-200 whitespace-pre-wrap">{detailDoc.lastError}</p>
                  </div>
                </div>
              )}

              {/* Cancellation reason */}
              {detailDoc.cancellationReason && (
                <div>
                  <h4 className="text-sm font-medium text-slate-300 mb-2">Motivo do Cancelamento</h4>
                  <div className="bg-central-fundo/50 border border-central-borda rounded-lg p-3">
                    <p className="text-sm text-slate-300">{detailDoc.cancellationReason}</p>
                  </div>
                </div>
              )}
        </CascaDeModal>
      )}

      {/* === MODAL: Cancelar === */}
      {cancelDoc && (
        // Motivo digitado: antes fechava ao clicar fora; agora só pelo × ou Fechar.
        // O × faz o que fazia o × antigo (fecha sem limpar o motivo); o Fechar limpa.
        <CascaDeModal
          largura="xs"
          titulo={confirmacaoDeCancelarNota(cancelDoc).titulo}
          onClose={() => setCancelDoc(null)}
          corpoClassName="p-6 space-y-4"
          rodape={
            <div className="ml-auto flex gap-3">
              <button onClick={() => {
                setCancelDoc(null);
                setSelectedReasonId('');
                setCancelReason('');
                setCustomReason('');
              }} className="px-4 py-2 text-slate-400 hover:text-white text-sm">
                Fechar
              </button>
              <button
                onClick={handleCancel}
                disabled={!cancelReason.trim() || cancelReason.trim().length < 15 || actionLoading === cancelDoc.id}
                className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg text-sm font-medium disabled:opacity-50"
              >
                {actionLoading === cancelDoc.id ? 'Cancelando...' : 'Confirmar Cancelamento'}
              </button>
            </div>
          }
        >
              {/* D2: qual nota e o que acontece com a fatura (utils/notasFiscais). */}
              <div className="space-y-2" data-testid="consequencia-do-cancelamento">
                {confirmacaoDeCancelarNota(cancelDoc).linhas.map((l, i) => (
                  <p key={i} className={`text-sm ${i === 0 ? 'text-slate-200 font-medium' : 'text-slate-300'}`}>{l}</p>
                ))}
              </div>
              {motivosErro && (
                <div role="alert" className={`text-xs ${TONE_TEXT.warning}`} data-testid="motivos-erro">
                  Não consegui carregar a lista de motivos: {motivosErro}. Use "Outro" e descreva o motivo.
                </div>
              )}

              {/* Dropdown de motivos */}
              <div>
                <label className="block text-sm text-slate-400 mb-2">Motivo do cancelamento *</label>
                <select
                  value={selectedReasonId}
                  onChange={e => {
                    setSelectedReasonId(e.target.value);
                    const reason = cancelReasonsList.find(r => r.id === e.target.value);
                    if (reason && reason.id !== 'outro') {
                      setCancelReason(reason.label);
                      setCustomReason('');
                    } else {
                      setCancelReason('');
                    }
                  }}
                  className={`w-full px-3 py-2 ${campo} rounded-lg focus:outline-none text-sm`}
                >
                  <option value="">Selecione um motivo...</option>
                  {cancelReasonsList.map(reason => (
                    <option key={reason.id} value={reason.id}>
                      {reason.label}
                    </option>
                  ))}
                  {/* Com a lista sem chegar, o "Outro" fica: o servidor valida o texto livre. */}
                  {!cancelReasonsList.some(r => r.id === 'outro') && <option value="outro">Outro</option>}
                </select>
              </div>

              {/* Campo customizado se "Outro" */}
              {selectedReasonId === 'outro' && (
                <div>
                  <label className="block text-sm text-slate-400 mb-2">Especifique o motivo *</label>
                  <textarea
                    value={customReason}
                    onChange={e => {
                      setCustomReason(e.target.value);
                      setCancelReason(e.target.value);
                    }}
                    rows={3}
                    className={`w-full px-3 py-2 rounded-lg placeholder-slate-500 focus:outline-none text-sm ${campo}`}
                    placeholder="Descreva o motivo (mínimo 15 caracteres)..."
                  />
                  <p className="text-xs text-slate-500 mt-1">
                    {customReason.length}/500 caracteres (mínimo 15)
                  </p>
                </div>
              )}

              {/* Preview do motivo selecionado */}
              {selectedReasonId && selectedReasonId !== 'outro' && (
                <div className="bg-central-fundo/50 border border-central-borda rounded-lg p-3">
                  <p className="text-xs text-slate-400">
                    {cancelReasonsList.find(r => r.id === selectedReasonId)?.description}
                  </p>
                </div>
              )}
        </CascaDeModal>
      )}

      {/* === MODAL: Upload Certificado === */}
      {showUploadCert && (
        // Arquivo e senha escolhidos: antes fechava ao clicar fora; agora só pelo ×
        // ou Cancelar, para não perder o que foi preenchido.
        <CascaDeModal
          largura="xs"
          titulo="Upload de Certificado Digital"
          onClose={() => setShowUploadCert(false)}
          corpoClassName="p-6 space-y-4"
          rodape={
            <div className="ml-auto flex gap-3">
              <button onClick={() => setShowUploadCert(false)} className="px-4 py-2 text-slate-400 hover:text-white text-sm">
                Cancelar
              </button>
              <button
                onClick={handleUploadCert}
                disabled={!uploadFile || !uploadPassword || actionLoading === -1}
                className="px-4 py-2 bg-primary hover:bg-primary-strong text-white rounded-lg text-sm font-medium disabled:opacity-50"
              >
                {actionLoading === -1 ? 'Enviando...' : 'Enviar'}
              </button>
            </div>
          }
        >
              {avisoDoUpload(certificates) && (
                <p className={`text-xs ${TONE_TEXT.warning}`} data-testid="aviso-do-upload">{avisoDoUpload(certificates)}</p>
              )}
              <div>
                <label className="block text-sm text-slate-400 mb-1">Tipo do certificado *</label>
                <div className="flex gap-3">
                  <button
                    onClick={() => setUploadType('empresa')}
                    className={`flex-1 px-4 py-2.5 rounded-lg text-sm font-medium border transition-colors ${
                      uploadType === 'empresa'
                        ? 'bg-slate-700 border-slate-600 text-white ring-1 ring-orange-500/60'
                        : 'bg-slate-900 border-slate-700 text-slate-400 hover:border-slate-600'
                    }`}
                  >
                    Empresa (e-CNPJ)
                  </button>
                  <button
                    onClick={() => setUploadType('pessoal')}
                    className={`flex-1 px-4 py-2.5 rounded-lg text-sm font-medium border transition-colors ${
                      uploadType === 'pessoal'
                        ? 'bg-slate-700 border-slate-600 text-white ring-1 ring-orange-500/60'
                        : 'bg-slate-900 border-slate-700 text-slate-400 hover:border-slate-600'
                    }`}
                  >
                    Pessoal (e-CPF)
                  </button>
                </div>
                <p className="text-xs text-slate-500 mt-1">
                  {uploadType === 'empresa' ? 'Usado para assinar NFS-e e NFCom' : 'Certificado pessoal do socio (contratos, gov.br, etc.)'}
                </p>
              </div>
              <div>
                <label className="block text-sm text-slate-400 mb-1">Nome (opcional)</label>
                <input
                  type="text"
                  value={uploadName}
                  onChange={e => setUploadName(e.target.value)}
                  className={`w-full px-3 py-2 rounded-lg placeholder-slate-500 focus:outline-none text-sm ${campo}`}
                  placeholder={uploadType === 'empresa' ? 'Ex: IPCOM Tecnologia' : 'Ex: Fabio da Silva'}
                />
              </div>
              <div
                onDragOver={e => e.preventDefault()}
                onDrop={e => {
                  e.preventDefault();
                  setUploadFile(e.dataTransfer?.files?.[0] || null);
                }}
              >
                <label className="block text-sm text-slate-400 mb-1">Arquivo .pfx *</label>
                <input
                  type="file"
                  accept=".pfx,.p12"
                  onChange={e => setUploadFile(e.target.files?.[0] || null)}
                  className="w-full text-sm text-slate-400 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-slate-700 file:text-slate-300 hover:file:bg-slate-600"
                />
              </div>
              <div>
                <label className="block text-sm text-slate-400 mb-1">Senha do certificado *</label>
                <input
                  type="password"
                  value={uploadPassword}
                  onChange={e => setUploadPassword(e.target.value)}
                  className={`w-full px-3 py-2 rounded-lg placeholder-slate-500 focus:outline-none text-sm ${campo}`}
                  placeholder="Senha do arquivo .pfx"
                />
              </div>
        </CascaDeModal>
      )}
    </div>
  );
};

export default FiscalTab;
